const kpnSlugs = ['kpn', 'kpnmedewerkers'];
const plusSlugs = ['plus-medewerkers', 'plus-b2b', 'plus-winactie'];
const lotSlugs = ['laboftomorrow'];

const isInGroup = (slug: string, groupSlugs: string[]) => groupSlugs.includes(slug);

export const getWishlistsMenuName = (slug: string) => {
  if (isInGroup(slug, kpnSlugs)) return 'dashboard_menu_wishlists_kpn';
  if (isInGroup(slug, plusSlugs)) return 'dashboard_menu_wishlists_plus';
  
  return 'dashboard_menu_wishlists';
};

export const getMyWishlistsMenuName = (slug: string) => {
  if (isInGroup(slug, plusSlugs)) return 'menus_label_my_wishlists_plus';
  
  return 'menus_label_my_wishlists';
};

export const getMySeatsMenuName = (slug: string) => {
  if (isInGroup(slug, plusSlugs)) return 'menus_label_my_seats_plus';
  if (isInGroup(slug, lotSlugs)) return 'menus_label_my_seats_lot';

  return 'menus_label_my_seats';
};